import React, { useContext, useState } from "react";
import { RicosContext } from "./../../ricos-context";
import { getIsModalOpen, useModalState } from "./../../ricos-modals/modal-service-provider";
import { EditIcon, ToggleButton } from "./../../toolbars-ui";
import { audioModals } from "../consts";
const AudioEditButton = ({ toolbarItem, dataHook }) => {
  const { isMobile, t } = useContext(RicosContext) || {};
  const [referenceElement, setReferenceElement] = useState(null);
  const isModalOpen = useModalState(getIsModalOpen(audioModals.settings));
  const onClick = () => toolbarItem.commands.click({ referenceElement, isMobile });
  return /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      dataHook,
      Icon: EditIcon,
      active: isModalOpen,
      label: t("AudioPlugin_Toolbar_Edit_Label"),
      tooltip: t("AudioPlugin_Toolbar_Edit_Label"),
      onClick,
      setRef: setReferenceElement
    }
  );
};
var AudioEditButton_default = AudioEditButton;
export {
  AudioEditButton_default as default
};
//# sourceMappingURL=AudioEditButton.js.map
